module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'dmwnl1vx',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
